<template>
  <div class="app_container">
    <div class="auto-title">请设置自动排班规则</div>
    <!-- form -->
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="260px"
      :rules="rules"
      :model="autoForm"
      ref="autoForm"
    >
      <el-row>
        <el-col>
          <el-form-item label="是否完全随机排班：" prop="suiji" required>
            <el-radio-group class="radio-content" v-model="autoForm.suiji">
              <el-radio class="radio-item" :label="0">完全随机</el-radio>
              <el-radio :label="1">不完全随机</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="是否优先一把手排第一期班级："
            prop="youxian"
            required
          >
            <el-radio-group class="radio-content" v-model="autoForm.youxian">
              <el-radio class="radio-item" :label="0">优先</el-radio>
              <el-radio :label="1">不优先</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="是否支持非一把手部位第一期班级："
            prop="buwei"
            required
          >
            <el-radio-group class="radio-content" v-model="autoForm.buwei">
              <el-radio class="radio-item" :label="0">补位</el-radio>
              <el-radio :label="1">不补位</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 报名学员 -->
    <div class="auto-title">请选择学员</div>
    <div class="search">
      <div class="search-right">
        <el-form
          class="serach-form"
          :inline="true"
          :model="searchForm"
          size="small"
        >
          <el-form-item class="select_btn_140">
            <el-select
              class="select_btn_style"
              v-model="searchForm.classId"
              placeholder="所在班级"
            >
              <el-option
                v-for="(item, i) in classList"
                :key="i"
                :label="item.className"
                :value="item.uuid"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="m-l-14">
            <el-input
              prefix-icon="el-icon-search"
              size="small"
              v-model.trim="searchForm.name"
              placeholder="姓名"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <butn btntype="primary" title="查询" @click="searchClick"></butn>
            <butn title="重置" @click="resetClick" class="czButn"></butn>
          </el-form-item>
        </el-form>
      </div>
      <div class="search-left">
        <butn
          btntype="primary"
          title="选择学员"
          @click="selectStudentClick"
        ></butn>
        <butn btntype="primary" 
              title="批量移动" 
              @click="batchMoveClick"
              :disabled="selectionList.length === 0">
        </butn>
        <butn
          btntype="primary"
          title="批量删除"
          @click="batchDeleteClick"
          :disabled="selectionList.length === 0"
        ></butn>
      </div>

      <el-table
        ref="tableList"
        :data="tableData"
        :row-key="getRowKeys"
        @selection-change="handleSelectionChange"
        empty-text="还未添加报名学员，点击左上角【选择学员】添加"
      >
        <el-table-column type="selection" :reserve-selection="true" width="40">
        </el-table-column>
        <el-table-column
          prop="className"
          label="所在班级"
          show-overflow-tooltip
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="userName"
          label="姓名"
          show-overflow-tooltip
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="deptName"
          label="单位"
          show-overflow-tooltip
          min-width="200"
        >
        </el-table-column>
        <el-table-column
          prop="unitPosition"
          label="单位及职务"
          min-width="400"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="操作"
          width="150">
          <template slot-scope="scope">
              <div style="display:flex">
                  <el-button type="text" @click="moveMember(scope.row)">移动</el-button>
                  <el-button type="text" @click="deleteMember(scope.row)">删除</el-button>
              </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="sizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        hide-on-single-page
      />
      <el-row>
        <el-col class="content-center">
            <el-button size="small" @click="$router.back()">返回</el-button>
            <el-button size="small" type="primary" @click="autoClick">自动排班</el-button>
        </el-col>
      </el-row>
    </div>
    <SelectTable
      :selctedTableInfo="selctedTableInfo"
      :groupNameList="classList.slice(1)"
      @closeDia="closeDialog"
      @sureMove="sureMove"
    />
  </div>
</template>

<script>
import butn from "@/components/button/index";
import rulesFactory from "@/utils/rules";
import {
  pageMoveStudent,
  judgeMoveStudent,
  relationClass,
  moveStudent,
} from "@/api/enrollOffline";
import SelectTable from "@/views/offlineClass/students/selectTable.vue";

export default {
  name: "autoSchedule",
  components: { butn, SelectTable },
  data() {
    return {
      getRowKeys(row) {
        return row.uuid;
      },
      props: {},
      autoForm: {
        suiji: "",
        youxian: "",
        buwei: "",
      },
      searchForm: {
        classId: null,
        name: "",
      },
      classList: [],
      rules: {
        suiji: [rulesFactory.required("请选择是否完全随机排班")],
        youxian: [rulesFactory.required("请选择是否优先一把手排第一期班级")],
        buwei: [rulesFactory.required("请选择是否支持非一把手部位第一期班级")],
      },
      tableData: [],
      currentPage: 1,
      size: 10,
      total: 0,
      classParentId: null,
      selectionList: [],
      selctedTableInfo: {
        show: false,
      },
    };
  },
  created() {
    // this.classParentId = this.$route.query.classParentId;
    this.classParentId = '1111111111';
    relationClass({ classParentId: this.classParentId }).then(
      ({ code, data }) => {
        if (code !== 0) return;
        data.splice(0, 0, {
          uuid: "",
          className: "全部",
        });
        this.classList = data;
      }
    );
    this.currentPage = 1;
    this.getList();

  },

  methods: {
    /**
     * 选择学员
     */
    selectStudentClick() {},
    /**
     * 批量移动
     */
    batchMoveClick() {
        let ids = this.selectionList.map(x => x.uuid)
        this.moveWay(ids);
    },
    /**
     * 单个移动学员
     */
    moveMember(row) {
        this.moveWay([row.uuid]);
    },
    /**
     * 批量删除
     */
    batchDeleteClick() {},
    // 单个删除学员
    deleteMember() {

    },
    /**
     * 点击搜索
     */
    searchClick() {
        this.currentPage = 1;
        this.getList();
    },
    /**点击重置 */
    resetClick() {

    },
    // 点击选择
    handleSelectionChange() {},
    pageChange(page) {
      this.currentPage = page;
      this.getList();
    },
    sizeChange(size) {
      this.currentPage = 1;
      this.size = size;
      this.getList();
    },
    getList() {
        let params = {
            classParentId: this.classParentId, 
            page: this.currentPage,
            limit: this.size,
        }
        pageMoveStudent(params).then(res => {
            if (res.code !== 0) return;
            // console.log('-------', res.data.records);
            this.tableData = res.data.records;
            this.total = res.data.total;
        })
    },
    /**
     * 点击自动排班
     */
    autoClick() {

    },

    moveWay(ids) {
      this.ids = ids;
      judgeMoveStudent({
        classParentId: this.classParentId,
        userIdList: ids,
      }).then(({ code, msg }) => {
        if (code !== 0) return;
        if (msg !== "操作成功") {
          this.$confirm(msg, "系统提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.selctedTableInfo.show = true;
          });
        } else {
          this.selctedTableInfo.show = true;
        }
      });
    },

    sureMove(row) {
        let ids = this.selectionList.map(e => e.uuid)
        moveStudent({ classId: row.uuid, userIdList: ids }).then(
        ({ code }) => {
          if (code !== 0) return;
           // 刷新    
          }
      );
    },

    closeDialog(){
        this.selctedTableInfo.show = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.app_container {
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 30px;
}
.auto-title {
  margin-top: 16px;
  margin-bottom: 16px;
  font-size: 14px;
}
.radio-content {
  margin-left: 20px;
  .radio-item {
    width: 100px;
  }
}

.search-right {
  float: right;
}

/deep/ .el-table th {
  background-color: #dce7fa;
}

.pagination{
    float: right;
    margin-top: 10px;
}
.content-center {
    margin-top: 30px;
    text-align: center;
}

</style>
